import { gql } from "@apollo/client";

const GET_ALL_ADVERTISERS = gql`
  query advertisers {
    advertisers {
      id
      cmsId
      name
    }
  }
`;

export default GET_ALL_ADVERTISERS;
